import * as emailjs from "@emailjs/browser";

export function sendEmail({ type, passengers, options, formData }) {
    // Construire la partie options
    const opts = Object.entries(options.options)
        .filter(([_, value]) => value)
        .map(([key]) => key)
        .join(', ') || "Aucune option";

    // Commencer le message avec le type
    let message = `✈️ ${type}\n\n`;

    // Gestion des passagers selon le type
    if (type === "Aller simple") {
        const count = passengers.count ?? "N/A";
        message += `👤 Passagers : ${count}\n`;
    } else if (type === "Aller-retour") {
        const allerCount = passengers.allerPassengersCount ?? "N/A";
        const retourCount = passengers.retourPassengersCount ?? "N/A";
        message += `👤 Passagers Aller : ${allerCount}\n`;
        message += `👤 Passagers Retour : ${retourCount}\n`;
    } else if (type === "Multi-destinations") {
        if (Array.isArray(formData.legs)) {
            formData.legs.forEach((leg, i) => {
                const legPassengers = leg.passengers?.count ?? "N/A";
                message += `👤 Passagers Étape ${i + 1} : ${legPassengers}\n`;
            });
        } else {
            message += `👤 Passagers : N/A\n`;
        }
    } else {
        // Cas fallback si nouveau type
        message += `👤 Passagers : ${passengers.count ?? "N/A"}\n`;
    }

    // Ajouter les options
    message += `🧾 Options : ${opts}\n\n`;

    // 🧭 Trajets
    if (type === "Multi-destinations" && Array.isArray(formData.legs)) {
        formData.legs.forEach((leg, i) => {
            message += `📍 Étape ${i + 1} : ${leg.from} → ${leg.to} (${leg.date} à ${leg.time})\n`;
        });
    } else if (type === "Aller simple") {
        const { from, to, date, time } = formData;
        message += `📍 De : ${from} → ${to}\n📅 Date : ${date} à ${time}\n`;
    } else if (type === "Aller-retour") {
        const { allerFrom, allerTo, allerDate, allerTime, retourFrom, retourTo, retourDate, retourTime } = formData;
        message += `📍 Aller : ${allerFrom} → ${allerTo} (${allerDate} à ${allerTime})\n`;
        message += `🔁 Retour : ${allerFrom} → ${allerTo} (${retourDate} à ${retourTime})\n`;
    }

    // 📞 Infos client
    if (formData.clientName || formData.clientFirstName || formData.clientEmail || formData.clientPhone) {
        message += `\n\n🧑‍💼 Coordonnées client :\n`;
        if (formData.clientName) message += `• Nom : ${formData.clientName}\n`;
        if (formData.clientFirstName) message += `• Prénom : ${formData.clientFirstName}\n`;
        if (formData.clientEmail) message += `• Email : ${formData.clientEmail}\n`;
        if (formData.clientPhone) message += `• Téléphone : ${formData.clientPhone}\n`;
    }

    const templateParams = {
        from_name: "Formulaire Réservation",
        message,
    };

    return emailjs.send('service_d1h9onh', 'template_ibjugjl', templateParams, 'juJQHUzuMusoEJes_')
        .then(() => alert("✉️ Email envoyé avec succès !"))
        .catch((err) => alert("Erreur lors de l'envoi de l'email : " + err.text));
}